import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import ExportButton from '../../common/ExportButton'
import { eventExportColumns } from '../../config/exportColumns/eventExportColumns'
import { appGetAllEvent } from '../../store/event'

function Event() {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const [exportFilters, setExportFilters] = useState({})
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Events</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllEvent({
										...params,
										...exportFilters,
										limit: 10000,
										sanstha: sansthaId || permissionOfSanstha,
										loading: false,
									}),
								)
							}
							columns={eventExportColumns}
							fileName="Events"
							sheetName="Event List"
							buttonText="Export Events"
						/>
						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/event/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Event
						</button>
					</div>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default Event
